module.exports = __webpack_public_path__ + "static/media/Ascending.Active.b6821040.svg";